import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ec977f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "D-Flex W-100",
  style: {"text-align":"left","margin-bottom":"15px","white-space":"nowrap"}
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_6 = { class: "D-Flex" }
const _hoisted_7 = { class: "DialogSection" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_9 = { class: "DialogSection" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "CookiesDialogFooter"
}
const _hoisted_12 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesNormalInput = _resolveComponent("CookiesNormalInput")!
  const _component_CookiesDescriptionBox = _resolveComponent("CookiesDescriptionBox")!
  const _component_CookiesDropInputObject = _resolveComponent("CookiesDropInputObject")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: 'CookiesDialog_' + _ctx.DialogIndex,
      class: "CookiesDialogdBody"
    }, [
      (_ctx.Saving)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.Loading.length > 0)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_CookiesNormalInput, {
              Placeholder: _ctx.Translate('Code'),
              CookiesInvalidInput: !(_ctx.MEMRead('D_Warehouse_Code') && _ctx.MEMRead('D_Warehouse_Code') !== ''),
              ErrorData: _ctx.ErrorsVisibilty && !(_ctx.MEMRead('D_Warehouse_Code') && _ctx.MEMRead('D_Warehouse_Code') !== ''),
              Res: 'D_Warehouse_Code',
              Default: ''
            }, null, 8, ["Placeholder", "CookiesInvalidInput", "ErrorData"]),
            _createVNode(_component_CookiesNormalInput, {
              Placeholder: _ctx.Translate('Name'),
              Res: 'D_Warehouse_Name',
              Default: ''
            }, null, 8, ["Placeholder"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_CookiesDescriptionBox, {
              Placeholder: _ctx.Translate('Description'),
              Res: 'D_Warehouse_Description'
            }, null, 8, ["Placeholder"])
          ]),
          (_ctx.Access('Branches_Read'))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_CookiesDropInputObject, {
                    CookiesInvalidInput: !(_ctx.MEMRead('D_Warehouse_Branch') && _ctx.MEMRead('D_Warehouse_Branch') !== ''),
                    ErrorData: _ctx.ErrorsVisibilty && !(_ctx.MEMRead('D_Warehouse_Branch') && _ctx.MEMRead('D_Warehouse_Branch') !== ''),
                    Name: _ctx.Translate('Branch'),
                    Default: '',
                    Options: _ctx.Branches,
                    Selectors: ['Name'],
                    Res: 'D_Warehouse_Branch'
                  }, null, 8, ["CookiesInvalidInput", "ErrorData", "Name", "Options"])
                ])
              ], 64))
            : _createCommentVNode("", true),
          _hoisted_10
        ])
      ])
    ], 8, _hoisted_1),
    (_ctx.Access(_ctx.DialogData.Editing ? 'Inventory_Warehouses_Edit': 'Inventory_Warehouses_Create'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
              style: {"background":"var(--colorr1)"},
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Cancel')), 1),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.SaveData && _ctx.SaveData(...args))),
              style: _normalizeStyle('background: ' + _ctx.Theme.UserColors.main),
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.DialogData.Editing ? _ctx.Translate('Save') : _ctx.Translate('Add')), 5)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}